// RootLayout.tsx
import { Outlet } from "react-router-dom";

const RootLayout = () => {
  return <Outlet />; {/* all routes will render here */}
};

export default RootLayout;
